<template>
  <span class="brand-logo" :class="`brand-logo--${tone}`" role="img" :aria-label="resolvedLabel">
    <img v-if="tone === 'brand'" class="brand-logo__mark" :src="colorLogo" alt="" />
    <span v-else class="brand-logo__mark brand-logo__mask brand-logo__mark--mono" />
    <span v-if="variant !== 'mark'" class="brand-logo__wordmark brand-logo__mask" :class="`brand-logo__wordmark--${variant}`" />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { BRAND } from '@design-system/brand';
import colorLogo from '@design-system/brand/彩色logo.svg';

const props = withDefaults(defineProps<{ variant?: 'mark' | 'zh' | 'zh-primary' | 'en' | 'en-primary'; tone?: 'brand' | 'current' | 'inverse'; label?: string }>(), { variant: 'zh-primary', tone: 'current', label: '' });
const resolvedLabel = computed(() => props.label || (props.variant.startsWith('en') ? `${BRAND.enName} ${BRAND.enDescriptor}` : BRAND.zhName));
</script>

<style src="@design-system/brand-logo.css"></style>
